export default "__VITE_ASSET__C4$7x0tG__"